<nav
  class="navbar navbar-expand-lg navbar-light bg-light px-2 position-relative"
>
  <div class="container-fluid d-flex justify-content-start align-items-center">
    <!-- โลโก้ -->
    <a routerLink="/" class="navbar-logo d-flex align-items-center me-2">
      <img
        src="assets/logo/Logo.png"
        class="object-fit-cover"
        alt="Logo"
        class="logo"
      />
    </a>

    <!-- ข้อความ Navbar Brand -->
    <div
      class="d-flex flex-wrap gap-1 align-items-center navbar-brand text-white"
    >
      <p class="mb-0">
        ระบบบริหารสินทรัพย์
        <span class="d-block d-md-none custom-text mt-1"
          >( {{ agencyName }} )</span
        >
      </p>
      <p class="mb-0 d-none d-md-block">( {{ agencyName }} )</p>
    </div>

    <!-- เมนูอื่นๆ -->
    <div class="d-flex align-items-center ms-auto gap-3">

      <div class="dropdown" *ngIf="permissionRoles && permissionRoles.length">
        <!-- Dropdown Toggle -->
        <div
          class="nav-link dropdown-toggle d-flex align-items-center gap-2 gap-md-3"
          role="button"
          data-bs-toggle="dropdown"
        >
          <!-- User Icon -->
          <div
            class="dropdown-toggle border-circle d-flex justify-content-center align-items-center cursor"
            style="width: 36px; height: 36px"
          >
            <img
              src="assets/icons/user.png"
              alt="User Icon"
              width="24"
              height="24"
            />
          </div>

          <!-- Username + Main Role -->
          <div class="d-none d-md-block text-start">
            <div class="fw-semibold text-dark-1">
              {{ userName | nameAbbreviation }}
            </div>
            <div *ngIf="mainRole" class="text-muted small">
              {{ mainRole.access_rights_name }}
            </div>
          </div>

          <img
            src="assets/icons/angle-down.png"
            alt="Dropdown Arrow"
            width="20"
            height="20"
            class="ms-2"
          />
        </div>

        <ul
          class="dropdown-menu dropdown-menu-end shadow-sm mt-2 p-2 rounded-3"
          style="min-width: 220px"
        >
          <li *ngIf="mainRole" class="px-3 py-2">
            <span class="text-primary fw-medium d-block">{{
              mainRole.access_rights_name
            }}</span>
          </li>

          <ng-container *ngIf="additionalRoles.length">
            <li><hr class="dropdown-divider" /></li>
            <li class="px-3 py-1 text-muted fw-semibold">สิทธิ์เพิ่มเติม</li>

            <li
              *ngFor="let role of additionalRoles"
              class="px-3 py-1 d-flex align-items-center"
            >
              <span class="text-primary fw-medium">
                {{ role.access_rights_name }}
              </span>

              <div class="ms-auto d-flex align-items-center gap-2">
                <div class="form-check form-switch m-0">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    [(ngModel)]="role.is_active"
                    (change)="onToggleRole(role)"
                  />
                </div>

                <span class="status-text">
                  {{ role.is_active? 'ใช้งาน':'ไม่ใช้งาน' }}
                </span>
              </div>

            </li>
          </ng-container>


          <li><hr class="dropdown-divider" /></li>
          <li class="px-3 pb-2 text-success fw-semibold">
            <p class="mb-0">ใช้งานอยู่</p>
          </li>
          <li>
            <button class="dropdown-item fw-semibold" (click)="handleSignOut()">
              ออกจากระบบ
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
